import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, tap } from 'rxjs';

export interface IGoogleSearchQuery {
    totalResults: string;
    count: number;
    startIndex: number;
    searchTerms: string;
    startPage: number;
}

export interface IGoogleSearchQueries {
    request: IGoogleSearchQuery[];
    nextPage?: IGoogleSearchQuery[];
    previousPage?: IGoogleSearchQuery[];
}

export interface IGoogleSearchResult {
    queries: IGoogleSearchQueries;
    items: IGoogleSearchItem[];
}

export interface IGoogleSearchItem {
    title: string;
    link: string;
    snippet: string;
}

const KEY = 'AIzaSyCWCM1tv3y3K5CjzQX8aat_T2OfxAWbEkE';
const CX = '010314335279624818652%3Aalh7ynbpkwc';
const BASE_URL = 'https://customsearch.googleapis.com/customsearch/v1';

@Injectable({
    providedIn: 'root',
})
export class GoogleSearchService {
    private _httpClient = inject(HttpClient);
    private _platformId = inject(PLATFORM_ID);

    feching = new BehaviorSubject<boolean>(false);

    getResults(query: string, index?: number): Observable<IGoogleSearchResult> {
        if (!isPlatformBrowser(this._platformId)) return EMPTY;

        let url = `${BASE_URL}?cx=${CX}&q=${query}&key=${KEY}`;
        if (index) url += `&start=${index}`;

        this.feching.next(true);
        return this._httpClient.get<IGoogleSearchResult>(url).pipe(tap(() => this.feching.next(false)));
    }
}
